import React from "react";

export type InvoiceSoldToKind = "member" | "non-member";

const soldToOptions: ReadonlyArray<{ value: InvoiceSoldToKind; label: string }> =
  [
    { value: "member", label: "Existing Member" },
    { value: "non-member", label: "Non-Member" },
  ];

// Claude Design "Sold To" segmented buttons, shared by the Custom/Advertising
// and Sponsorship invoice forms (CMP Dashboard (11) 5395-5401, 5764-5768).
export const SoldToToggle = ({
  onChange,
  value,
}: {
  onChange: (value: InvoiceSoldToKind) => void;
  value: InvoiceSoldToKind;
}) => (
  <div className="flex w-fit max-w-full overflow-hidden rounded-lg border border-[#ECECEC]">
    {soldToOptions.map((option) => {
      const isActive = value === option.value;

      return (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={isActive}
          className={`whitespace-nowrap px-5 py-2.5 text-sm font-semibold leading-[normal] transition [&+button]:border-l [&+button]:border-[#ECECEC] ${
            isActive ? "bg-[#E1A731] text-white" : "bg-white text-[#0A0A0A]"
          }`}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

// Claude Design (21) CMP Dashboard.dc.html:5652-5658: the gold Create Invoice
// button uses the Preview Invoice box (14px/600, 12px 20px, 8px radius,
// normal line height), so both buttons are the same height (Moeen, IF11 N7).
export const createInvoiceButtonSx = {
  backgroundColor: "#E1A731",
  borderRadius: "8px",
  boxShadow: "none",
  color: "#fff",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "normal",
  minWidth: 0,
  padding: "12px 20px",
  textTransform: "none",
  "&:hover": { backgroundColor: "#C9931F", boxShadow: "none" },
} as const;

// Claude Design filled black "Preview Invoice" button on the Ticket,
// Sponsorship and Advertising invoice forms (CMP Dashboard (11) 3913, 5593, 5896).
export const PreviewInvoiceButton = ({
  disabled,
  onClick,
}: {
  disabled?: boolean;
  onClick: () => void;
}) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className="inline-flex items-center gap-2 rounded-lg bg-[#0A0A0A] px-5 py-3 text-sm font-semibold leading-[normal] text-white transition hover:bg-[#2A2A2A] disabled:cursor-not-allowed disabled:opacity-50"
  >
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="1.8"
      strokeLinecap="round"
      className="h-[17px] w-[17px]"
    >
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z" />
      <circle cx="12" cy="12" r="2.6" />
    </svg>
    Preview Invoice
  </button>
);
